angular.module('app.entity.audit')
    .filter('labelYesNo', ['gettext', function(gettext){
        return function(value){
            return !! value ? gettext('Sí') : gettext('No');
        };
    }]);
